export default __webpack_public_path__ + "static/media/sponsor.872c218f.png";